import type { DateYMDString } from '@lt/api/dist/types/date';
import type { PackageStateType } from './types';

export const datesInfoDTO = (data: unknown): PackageStateType['dates_info'] => {
  if (data && typeof data === 'object') {
    return {
      start_date:
        'start_date' in data ? dateYMDStringDTO(data.start_date) : null,
      check_in: 'check_in' in data ? dateYMDStringDTO(data.check_in) : null,
      end_date: 'end_date' in data ? dateYMDStringDTO(data.end_date) : null,
      check_out: 'check_out' in data ? dateYMDStringDTO(data.check_out) : null,
      original_nights:
        'original_nights' in data && typeof data.original_nights === 'number'
          ? data.original_nights
          : 0,
      nights_count:
        'nights_count' in data && typeof data.nights_count === 'number'
          ? data.nights_count
          : 0,
      nights_shift:
        'nights_shift' in data && typeof data.nights_shift === 'number'
          ? data.nights_shift
          : 0,
    };
  }

  return null;
};

export const dateYMDStringDTO = (data: unknown): DateYMDString | null => {
  if (data && typeof data === 'string') {
    return data as DateYMDString;
  }

  return null;
};
